import { render } from "./about.vue?vue&type=template&id=0cb5b99a"
import script from "./about.vue?vue&type=script&lang=js"
export * from "./about.vue?vue&type=script&lang=js"

import "./about.vue?vue&type=style&index=0&id=0cb5b99a&lang=scss"

import exportComponent from "D:\\丹捷\\项目新\\source\\web_site\\sirimuch\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__